export interface PagedResult<T> {
  items: T[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface ApiError {
  message: string;
  statusCode: number;
  details?: string;
}

// Backend sends numeric enum values: 0, 1, 2, 3
export enum AuthType {
  UsernamePasswordCertificate = 0,  // Banks
  UsernamePassword = 1,              // Payment processors
  ApiKeyKeypair = 2,                 // Card processors
  CustomerIdSignature = 3            // Danske Bank (CustomerId + WS-Security signature)
}

export interface Provider {
  id: string;
  name: string;
  type: 'ISO' | 'IOBS';
  authType: AuthType;
  clientCount: number;
  services: ServiceTarget[];
}

export interface ServiceTarget {
  id: string;
  serviceName: string;
  serviceUrl: string;
  certificateNeeded: boolean;
}

export interface SystemStats {
  totalOrganizations: number;
  totalClients: number;
  totalManagementClients: number;
  activeProviders: number;
  clientsByStatus: StatusCount[];
  providerUsage: ProviderUsage[];
}

export interface ProviderUsage {
  providerName: string;
  clientCount: number;
  isActive: boolean;
}

export interface StatusCount {
  status: string;
  count: number;
}

export interface ManagementClient {
  clientId: string;
  organizationName: string;
  organizationId: string;
  scopes: string[];
  created: string;
  businessSystem: string;
  clientIPs: string[];
}